// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"f51922d2","110":"cfc33c8d","368":"850be82f","406":"a9bacbca","453":"452420c8","577":"fc14106c","723":"987ffd8c","744":"d68437b5"}[chunkId] + ".chunk.js";
};